export default __webpack_public_path__ + "static/media/007-cash register.daede963.svg";